export const CURRENCIES = [
  {
    value: "KZT",
    name: "Казахский тенге",
  },
  {
    value: "TRY",
    name: "Турецкая лира",
  },
  {
    value: "EUR",
    name: "Евро",
  },
  {
    value: "USD",
    name: "Доллар США",
  },
  {
    value: "AED",
    name: "Дихрам ОАЭ",
  },
  {
    value: "RUB",
    name: "Российский рубль",
  },
];

export const CRYPTO_CURRENCIES = [
  {
    value: 'USDT',
    name: 'USDT'
  },
  {
    value: 'USDC',
    name: 'USDC'
  },
  {
    value: 'BTC',
    name: 'BTC'
  },
  {
    value: 'ETH',
    name: 'ETH'
  },
  {
    value: 'BNB',
    name: 'BNB'
  }
];
